import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import {
  PushAnalyticsEvent,
  syntheticEventHubEvent,
  getRawGaSessionCookie
} from '@/analytics/analyticsUtils';
import { AnalyticsEventName } from '@/analytics/constants';

export const useAnalytics = () => {
  const auth = useAuth();

  const userId =
    (auth?.user?.profile?.IndividualSK as string)?.length > 0
      ? (auth.user?.profile?.IndividualSK as string)
      : '000000';

  // Cookies are read per call: GA sets them asynchronously after load, so a value
  // captured once at mount could stay 'NoSession' for the whole component lifetime.
  const getSessionId = useCallback(() => {
    const gaCookie = getRawGaSessionCookie();
    return gaCookie ? `${gaCookie}.${userId}` : 'NoSession';
  }, [userId]);

  const trackEvent = useCallback(
    (event: AnalyticsEventName, eventData: Record<string, unknown> = {}) => {
      PushAnalyticsEvent(event, eventData);

      syntheticEventHubEvent({
        event,
        sessionId: getSessionId(),
        ...eventData
      });
    },
    [getSessionId]
  );

  return { trackEvent, sessionId: getSessionId(), userId };
};
